import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
export type HintProps = {
  size?: 'compact' | 'default';
  children: string;
  className?: string;
  hasError?: boolean;
  id?: string;
};
const Hint = t0 => {
  const $ = _c(8);
  const {
    children,
    className,
    hasError: t1,
    id,
    size: t2
  } = t0;
  const hasError = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "default" : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cx("fp-hint fp-custom-appearance mt-2", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== hasError || $[4] !== id || $[5] !== size || $[6] !== t3) {
    t4 = <div id={id} className={t3} data-has-error={hasError} data-size={size}>{children}</div>;
    $[2] = children;
    $[3] = hasError;
    $[4] = id;
    $[5] = size;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default Hint;